module.exports = __webpack_public_path__ + "img/catch-bg-blur.f3e4cfab.png";